import { Box, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { TooltipData } from './types';

interface TooltipProps {
  data: TooltipData | null;
  visible: boolean;
}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(({ data, visible }, ref) => {
  if (!visible || !data) {
    return null;
  }

  return (
    <Box
      ref={ref}
      sx={{
        position: 'absolute',
        left: data.x,
        top: data.y,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace',
        pointerEvents: 'none',
        zIndex: 1000,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
        minWidth: '120px',
        maxWidth: '200px',
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 'bold', marginBottom: '4px', display: 'block' }}
      >
        {data.timestamp}
      </Typography>
      {data.series.map((series, index) => {
        const label =
          typeof series.label === 'string' ? series.label : series.label.textContent || 'Unknown';
        const color = typeof series.color === 'string' ? series.color : '#000';

        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '2px',
            }}
          >
            <Box
              sx={{
                width: '8px',
                height: '8px',
                backgroundColor: color,
                marginRight: '6px',
                borderRadius: '50%',
              }}
            />
            <Typography variant="caption" sx={{ flex: 1 }}>
              {label}:
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 'bold', marginLeft: '4px' }}>
              {series.value.toLocaleString()}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
